import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
// module id = null
// module chunks = 